/* File: securityAlertsBadgeContext.jsx
 * Bump badgeRefreshToken after security alert mutations so the main sidebar can refetch the open-alerts count.
 */
import { createContext, useCallback, useContext, useMemo, useState } from "react";

const SecurityAlertsBadgeContext = createContext({
	badgeRefreshToken: 0,
	requestSecurityAlertsBadgeRefresh: () => {}
});

export function SecurityAlertsBadgeProvider({ children }) {
	const [badgeRefreshToken, setBadgeRefreshToken] = useState(0);
	const requestSecurityAlertsBadgeRefresh = useCallback(() => {
		setBadgeRefreshToken((t) => t + 1);
	}, []);
	const value = useMemo(
		() => ({ badgeRefreshToken, requestSecurityAlertsBadgeRefresh }),
		[badgeRefreshToken, requestSecurityAlertsBadgeRefresh]
	);
	return (
		<SecurityAlertsBadgeContext.Provider value={value}>{children}</SecurityAlertsBadgeContext.Provider>
	);
}

export function useSecurityAlertsBadge() {
	return useContext(SecurityAlertsBadgeContext);
}
